const byteToHex = [];

for (let i = 0; i < 256; i += 1) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

export const getRandomBuffer = () => {
  const rnds = new Array(16);

  for (let i = 0, r; i < 16; i += 1) {
    // eslint-disable-next-line no-bitwise
    if ((i & 0x03) === 0) {
      r = Math.random() * 0x100000000;
    }

    // eslint-disable-next-line no-bitwise, no-mixed-operators
    rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
  }

  return rnds;
};

export const bytesToUuid = (buf) => {
  let i = 0;
  const uuid = ([
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]],
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]], '-',
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]], '-',
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]], '-',
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]], '-',
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]],
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]],
    byteToHex[buf[i += 1]], byteToHex[buf[i += 1]],
  ]).join('');

  return uuid;
};

export default () => bytesToUuid(getRandomBuffer());
